import React, { useState } from "react";
import { Layout } from "antd";
import { Header } from "./header";
import { ViewControls } from "./view-controls";
import { DailyOverview } from "./daily-overview";

const { Content } = Layout;

export const DispatchSummaries: React.FC = () => {
  const [viewMode, setViewMode] = useState<string>("daily");
  const [selectedDate, setSelectedDate] = useState<string>("2025-03-07");

  return (
    <Layout style={{ background: "#F7FAFC" }}>
      <Header viewMode={viewMode} setViewMode={setViewMode} />
      <ViewControls
        viewMode={viewMode}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        compactView={false}
        setCompactView={() => {}}
      />
      <Content>
        {viewMode === "daily" && (
          <DailyOverview
            selectedDate={selectedDate}
            compactView={false}
          />
        )}
        {/* Other views like Week Planning, Resources, and Analytics can be added here */}
      </Content>
    </Layout>
  );
};
